import ro from './ro.json';
import en from './en.json';

let language = ro;

if(typeof window !== 'undefined' && typeof window.Storage !== 'undefined') {
  language = localStorage.getItem('language') === 'en' ? en : ro;
}

export function currentLanguage() {
  return language === ro ? 'ro' : 'en';
}

export function t(string) {
  if(string in language) {
    return language[string];
  }

  return 'Missing translation: ' + string;
}

export function switchLanguage() {
  if(language === en) {
    localStorage.setItem('language', 'ro');
  } else {
    localStorage.setItem('language', 'en');
  }
  window.location.reload();
}



/** WEBPACK FOOTER **
 ** ./src/lang/trans.js
 **/